import React, { Component } from "react";
import "./warning_bar.scss";
import { If } from "react-extras";
import VerifyEmailWarning from "./../warnings/verify_email";
import { withRouter } from "react-router-dom";
import { userHasRole } from "../../../lib/user";
import UserRoles from "../../../constants/roles";

class WarningBar extends Component {
  componentDidMount() {
    if (userHasRole(this.props.user, UserRoles.Sponsor)) {
      this.props.fetchSubscriptionForUser(this.props.user.uuid);
    }
  }

  shouldRenderVerifyEmail = () => {
    if (this.props.user?.hasVerifiedEmail) return false;
    if (!this.props.user) return false;
    if (!userHasRole(this.props.user, UserRoles.Sponsor)) {
      return true;
    }
    return !!Object.keys(this.props.subscriptions).length;
  };
  render() {
    return (
      <div>
        <If condition={this.shouldRenderVerifyEmail()}>
          <div className="warning-bar bg-warning">
            <VerifyEmailWarning
              user={this.props.user}
              sendVerificationEmail={this.props.sendVerificationEmail}
            />
          </div>
        </If>
      </div>
    );
  }
}

export default withRouter(WarningBar);
